export const MEMBERSHIP_TIERS = {
  FREE: "free",
  CINEPHILE: "cinephile",
  FANATIC: "fanatic",
};

export const BILLING_STATUSES = {
  NONE: "none",
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending",
  CANCELLED: "cancelled",
  SUSPENDED: "suspended",
  EXPIRED: "expired",
};

export const FORUM_LIMITS = {
  free: {
    daily: 10,
    rolling30Days: 100,
  },

  cinephile: {
    daily: 25,
    rolling30Days: 250,
  },

  fanatic: {
    daily: Infinity,
    rolling30Days: Infinity,
  },
};

const getPeriodEndMs = (value) => {
  if (!value) return 0;

  // Firestore Timestamp
  if (typeof value.toMillis === "function") {
    return value.toMillis();
  }

  if (typeof value.toDate === "function") {
    return value.toDate().getTime();
  }

  // Date JavaScript
  if (value instanceof Date) {
    return value.getTime();
  }

  // Date reçue sous forme de chaîne
  const parsed = new Date(value).getTime();

  return Number.isNaN(parsed) ? 0 : parsed;
};

export const getMembershipState = (subscription) => {
  const membershipTier = subscription?.planId || "free";
  const billingStatus = subscription?.status || "none";
  const currentPeriodEnd = subscription?.currentPeriodEnd || null;

  const accessOverridePlanId =
    subscription?.accessOverridePlanId || null;

  const accessOverrideUntil =
    subscription?.accessOverrideUntil || null;

  const isPaidTier =
    ["cinephile", "fanatic"].includes(membershipTier);

  const hasRemainingPaidPeriod =
    billingStatus === "cancelled" &&
    getPeriodEndMs(currentPeriodEnd) > Date.now();

  const hasPaidAccess =
    isPaidTier &&
    (
      billingStatus === "active" ||
      hasRemainingPaidPeriod
    );

  const hasActiveAccessOverride =
    hasPaidAccess &&
    ["cinephile", "fanatic"].includes(accessOverridePlanId) &&
    getPeriodEndMs(accessOverrideUntil) > Date.now();

  const effectiveTier = hasPaidAccess
    ? (
      hasActiveAccessOverride
        ? accessOverridePlanId
        : membershipTier
    )
    : "free";

  return {
    membershipTier,
    billingStatus,
    effectiveTier,
    hasPaidAccess,
    hasRemainingPaidPeriod,
    currentPeriodEnd,

    accessOverridePlanId,
    accessOverrideUntil,
    hasActiveAccessOverride,
  };
};

export const getForumLimits = (effectiveTier = "free") => {
  return FORUM_LIMITS[effectiveTier] || FORUM_LIMITS.free;
};